<template>
    <GenericForm
        class="column"
        :fields="fields"
        :asyncErrors="asyncErrors"
        @submit="$emit('submit')"
    >
        <template slot-scope="slotProps">
            <NumberInput
                v-model="fields.amount.value"
                name="amount"
                :unit="$t('currencyAbbreviation')"
                :label="`${$t('amount')}:`"
                :errorMessage="slotProps.errors.amount"
                @valueChanged="slotProps.onValueChanged"
            />
            <CustomInput
                v-if="needsUserData"
                name="dateOfBirth"
                v-model="fields.dateOfBirth.value"
                label="date of birth"
                placeholder="MM.DD.YYYY"
                :errorMessage="slotProps.errors.dateOfBirth"
                @valueChanged="slotProps.onValueChanged"
            />
            <CustomInput
                v-if="needsUserData"
                name="firstName"
                v-model="fields.firstName.value"
                label="first name"
                :errorMessage="slotProps.errors.firstName"
                @valueChanged="slotProps.onValueChanged"
            />
            <CustomInput
                v-if="needsUserData"
                name="lastName"
                v-model="fields.lastName.value"
                label="last name"
                :errorMessage="slotProps.errors.lastName"
                @valueChanged="slotProps.onValueChanged"
            />
            <CustomInput
                v-if="needsUserData"
                name="email"
                v-model="fields.email.value"
                label="E-mail"
                :errorMessage="slotProps.errors.email"
                @valueChanged="slotProps.onValueChanged"
            />
            <CustomSelect
                v-if="showShops"
                v-model="fields.shop.value"
                name="shop"
                :options="shops"
                :label="'shops'"
                :labelSuffix="':'"
                idField="comTradeId"
                :displayFunction="shopDisplayFunction"
                :errorMessage="slotProps.errors.shop"
                @valueChanged="slotProps.onValueChanged"
            />
            <TaxLimitsSummary
                v-if="isTaxable"
                :amount="fields.amount.value"
                :taxLimits="withdrawalTaxLimits"
                :minTaxableAmount="minTaxableAmount"
                :shouldRoundTax="true"
                label="withdrawal"
            />
            <button
                type="submit"
                class="btn btn__primary--yellow btn--lg btn--w-96 btn__primary--yellow"
            >
                {{ $t('withdrawal') | capitalize }}
            </button>
        </template>
    </GenericForm>
</template>

<script>
    import config from '@config';

    export default {
        props: {
            shops: {
                type: Array,
                required: false,
                default: () => []
            },
            fields: {
                type: Object,
                required: true,
            },
            asyncErrors: {
                type: Object,
                required: true,
            },
            withdrawalTaxLimits: {
                type: String,
                required: true,
            },
            needsUserData: {
                type: Boolean,
                required: false,
                default: false,
            },
            isTaxable: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        computed: {
            showShops() {
                return !!this.shops.length;
            },
            minTaxableAmount() {
                return config.app.user.withdrawal.minTaxableAmount;
            },
        },
        methods: {
            shopDisplayFunction(shop) {
                return `${shop.city}, ${shop.address}`;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/withdrawal/components/forms/WithdrawalForm.vue